export const windowTypeNames = {
  proof_upload_window: 'Proof upload',
  declaration_window: 'Declaration',
};

export const FBPSettingsDescriptions = {
  'auto-open-declaration-window-new-employees': {
    M3S2: 'Auto-open declaration window for new joiners with Flexi benefits part of their compensation. Employees will be notified via email',
    DEFAULT:
      'Auto-open declaration window for new joiners with FBP component in their salary structure for a certain time after joining. Employees will be notified via email.',
  },
  'auto-open-declaration-window-salary-revised-employees': {
    M3S2: 'Auto-open declaration window for salary revised employees with flexi benefits part of their compensation. Employees will be notified via email',
    DEFAULT:
      'Auto-open declaration for salary-revised employees with flexible benefit components in their salary structure. Employees will be notified via email.',
  },
  'taxable-by-default': {
    M3S2: 'Consider unclaimed flexi allowances to be taxable by default',
    DEFAULT: 'Consider FBP allowances to be taxable by default',
  },
  'taxable-by-default-description': {
    M3S2: 'Choose tax exemption for unclaimed flexi allowances',
    DEFAULT:
      "By default the flexible component will not be tax exempted and will be added to the employee's taxable salary",
  },
  'tax-exemption-from-month': {
    M3S2: 'Unclaimed flexi allowances will be taxable from this month onwards',
    DEFAULT: 'FBP allowance will be taxable from this month onwards',
  },
  'tax-exemption-from-month-description': {
    M3S2: 'If no month is selected below, unclaimed flexi allowances will automatically become taxable for March payroll',
    DEFAULT:
      'If no month is selected below, it will automatically become taxable for March payroll',
  },
  'auto-release-unclaimed-benefit-description': {
    M3S2: 'If no month is selected below, unclaimed flexi allowances will automatically be released in March payroll',
    DEFAULT: 'If no month is selected below, it will automatically be released in March payroll',
  },
  'proof-upload-window-config': {
    M3S2: 'Define employee level custom window during which the selected employee can declare/upload proofs for flexible benefits',
    DEFAULT:
      'Define the period during which employees upload their proof for their flexible benefit declarations',
  },
  'proof-upload-till-dismissal-config': {
    M3S2: 'Employees in dismissed state can submit proofs for flexi allowances until their Last working date to claim tax exemption. Unclaimed flexi allowances will be taxable as part of Full & Final settlement',
    DEFAULT:
      'Employees under the dismissals status, can submit their proofs before their exit to ensure they get the flexible benefits',
  },
  'custom-window-settings-description': {
    M3S2: 'Define employee level custom window during which the selected employee can declare/upload proofs for flexible benefits',
    DEFAULT:
      'Define the period during which employees upload their proof for their flexible benefits declarations',
  },
};
